// TODO Убрать из глобалки

let ajax_sms_instruction_id = 0;

document.addEventListener('DOMContentLoaded', function () {
    // TODO Используется в ЛК и, вроде, на страницах статей и т.п. для переключения меню слева. Вынести туда

    $('.js-personal-nav-item__has-child').click(function (event) {
        if (event.target.tagName === 'A') return;

        $(this).toggleClass('personal-nav-item__open');

        $('.js-personal-nav-item__child-' + $(this).data('index')).toggleClass('hidden');
    })

    $('.js_btn-personal-nav_toggle-active').click(function () {
        let el_filter_btn = this,
            el_backdrop = document.querySelector('.personal-nav__backdrop') || document.createElement('div');

        if (el_backdrop.className) {
            el_backdrop.hidden = el_filter_btn.classList.contains('btn-personal-nav_active');
        } else {
            el_backdrop.className = 'personal-nav__backdrop';

            add_backdrop(el_filter_btn.parentElement);

            el_backdrop.addEventListener('click', function () {
                $('.js_btn-personal-nav_toggle-active').removeClass('btn-personal-nav_active');
                el_backdrop.hidden = true;
            });

            function add_backdrop(parent) {
                if (!parent) return;

                if (parent.classList.contains('box')) {
                    parent.insertAdjacentElement('beforeend', el_backdrop);
                } else {
                    add_backdrop(parent.parentElement);
                }
            }
        }

        [].forEach.call(document.querySelectorAll('.js_btn-personal-nav_toggle-active'), function (el) {
            if (el === el_filter_btn) return;

            el.classList.remove('btn-personal-nav_active');
        });

        el_filter_btn.classList.toggle('btn-personal-nav_active');
    })
})

// Используется при выборе способа оплаты "Расчетный счет" (/payselect?payselect=Bill&order_id=48&pay=0)
window.showOrigDocsArea = function () {
    if ($('#orig_docs_area').css('display') == 'none') {
        $('#orig_docs_area').slideDown('slow')
    } else {
        $('#orig_docs_area').slideUp('slow')
    }
}

// Используется при выборе способа оплаты
window.smsInstruction = function (order_id, method) {
    if (ajax_sms_instruction_id) {
        ajax_sms_instruction_id.abort()
    }

    ajax_sms_instruction_id = $.ajax({
        type: 'POST',
        dataType: 'json',
        url: g_params.url_prefix + '/ajax_sms_instruction',
        data: {
            order_id: order_id,
            method: method
        },
        success: function (data) {
            if (data.status == 1) {
                alert('Инструкция по оплате отправлена вам СМС-сообщением.');
            } else if (data.status == 2) {
                alert('Мы уже отправляли вам эту инструкцию.');
            } else if (data.status == 0) {
                alert('Инструкция не отправлена. Возможно вы указали неправильный телефон при оформлении заказа.');
            }
        }
    })
}
